import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import DialogSubmit from "./DialogSubmit";
import { toast } from "react-toastify";
import { API_ENDPOINT } from "../../utils/constants";
import { getErrorResponse, getHeader, toastError } from "../../utils/util";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import axios from "axios";
import CustomCircularP from "../../widgets/CustomCircularP";
const ListButtons = ({ type = "button" }) => {
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/api/get-reply-items?type=${type}`
  );

  const handleItem = () => {
    setOpen(true);
  };
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  const handleDelete = (item) => {
    setToDelete(item);
    setDeleteOpen(true);
  };
  return (
    <div>
      <CustomCircularP show={deleting} />
      <SimpleYesNoDialog
        title={"Please Confirm"}
        message={`Are you sure you want to delete ${toDelete?.text}?`}
        show={deleteOpen}
        setShow={setDeleteOpen}
        onYes={async () => {
          setDeleteOpen(false);
          try {
            setDeleting(true);
            const response = await axios.delete(
              `${API_ENDPOINT}/api/delete-reply-item/${toDelete?.text}`,
              getHeader()
            );
            toast.success(response.data.message);
            refetch();
          } catch (error) {
            toastError(error);
          } finally {
            setDeleting(false);
          }
        }}
      />
      <DialogSubmit
        open={open}
        onClose={() => setOpen(false)}
        title={`Add ${type}`}
        inputLabel="Text"
        submitLabel="Send"
        endpoint={`${API_ENDPOINT}/api/add-reply-item`}
        transformPayload={(q) => ({ text: q, type: type })}
        onSuccess={(data) => {
          toast.success(data.message);
          refetch();
        }}
        onError={(error) => {
          toast.error(getErrorResponse(error));
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack vertically on mobile, row on larger screens
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" }, // Align items properly for both layouts
          gap: { xs: 2, sm: 0 }, // Add gap when stacked, remove when in row
          mb: 3,
        }}
      >
        <Typography
          fontSize={"18px"}
          fontWeight={500}
          sx={{ mb: { xs: 1, sm: 0 } }}
        >
          {type === "button" ? "Buttons" : "Text"} List
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleItem}
          sx={{ width: { xs: "100%", sm: "auto" } }} // Full width on mobile, auto on larger screens
        >
          Add {type}
        </Button>
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {data?.map((item, i) => (
          <Chip
            onDelete={() => handleDelete(item)}
            key={i}
            variant="outlined"
            clickable
            label={item.text}
          />
        ))}
      </Box>
    </div>
  );
};

export default ListButtons;
